<a class="btn btn-rounded small"
   uiSref="searchresultbytag"
   [uiParams]="{contentType: 'all', query: tag}"
>{{tag}}</a>
